<template>
  <div>
    <pinch-zoom backgroundColor="transparent">
      <img src="/static/img/30/asztal.png" class="px-4 py-10"/>
    </pinch-zoom>
  </div>
</template>
<script>
import PinchZoom from 'vue-pinch-zoom';

export default {
  components: { PinchZoom },
  props: ['params']
}
</script>

<style lang="scss" scoped>
div {
  position: absolute;
  inset: 0;
}
</style>
